import { ViewMode } from '@playbooks/action-cards-utils'
import { ToggleGroup, ToggleGroupItem } from '@playbooks/ui/components/toggle-group'
import { Assessment, Response as ResponseType } from '@playbooks/core/src/interfaces/ActionCard'
import { cn } from '@playbooks/ui/lib/utils'

import Response from './Response'
import { useAppContext } from '../../../contexts/AppContext'

interface MultiSelectProps {
  assessment: Assessment
  responses: ResponseType[]
  onValueChange: (response: ResponseType) => void
}

export function MultiSelect({ responses, onValueChange }: MultiSelectProps) {
  const {
    settings: { viewMode },
  } = useAppContext()
  const isFunnelView = viewMode === ViewMode.FUNNEL
  return (
    <ToggleGroup
      type="multiple"
      orientation="vertical"
      className={cn('w-full items-start flex-col gap-3', 'group-data-[view=doc]/app:gap-0.5')}
    >
      {responses.map(option => (
        <ToggleGroupItem
          key={option.id}
          value={option.id.toString()}
          className={cn(
            'w-full justify-start whitespace-normal h-auto hover:bg-transparent text-left px-0!',
            'data-[state=on]:bg-transparent',
            'group-data-[view=funnel]/app:pl-0',
          )}
          asChild
        >
          <div onClick={() => onValueChange(option)}>
            <Response response={option} iconClass={option.iconClass} isFunnelView={isFunnelView} />
          </div>
        </ToggleGroupItem>
      ))}
    </ToggleGroup>
  )
}
